export default {
  presets: {
    light: {
      backgroundPrimary: '#f9f9f9',
      backgroundSecondary: '#f3f4f6',
      backgroundCardPrimary: '#f5f5f5',
      backgroundCardSecondary: '#ECFDE6',
      success: '#2e7d32',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
